<ng-container *cftI18n="let t">
  {{ t('heroSearchbar.placeholder') }}
  <div class="flex w-[2.25rem] justify-center rounded-full bg-vermillon-500 p-[0.375rem]">
    <fa-icon [icon]="searchIcon" class="text-white"></fa-icon>
  </div>
</ng-container>
